<div class="w-full p-gutter text-center">
    <div class="w-20 h-20 rounded-full bg-red/10 ltr:mr-3 rtl:ml-3 flex items-center justify-center" style="position: relative; display: inline-block;">
        <mat-icon class="w-full max-w-lg mx-auto mt-8" style="color: red;">lock</mat-icon>
    </div>

    <h1 class="display-3 font-medium m-6">Access Denied</h1>
    <h2 class="headline m-6">You do not have permission to access this resource</h2>
</div>
